export const FILE_RECT_ICONS = {
  pdf: 'https://dashboard-v2-images.s3.us-east-1.amazonaws.com/new-file-pdf.png',
  csv: 'https://dashboard-v2-images.s3.us-east-1.amazonaws.com/new-file-csv.png',
  doc: 'https://dashboard-v2-images.s3.us-east-1.amazonaws.com/new-file-doc.png',
  docx: 'https://dashboard-v2-images.s3.us-east-1.amazonaws.com/new-file-doc.png',
  txt: 'https://dashboard-v2-images.s3.us-east-1.amazonaws.com/new-file-txt.png',
  xls: 'https://dashboard-v2-images.s3.us-east-1.amazonaws.com/new-file-xls.png',
  xlsx: 'https://dashboard-v2-images.s3.us-east-1.amazonaws.com/new-file-xls.png',
};

export const getFileExtension = fileName => {
  return fileName?.split('.').pop()?.toLowerCase() || '';
};

export const isImageFile = fileType => {
  return fileType?.startsWith('image/');
};
